<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('homepage.gender_equality')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
        </div>
        <section class="section py-3">
            <div class="container">
                <div class="tab_div_top">
                    <el-row :gutter="15">
                        <el-col :sm="12" :md="8" :lg="6" class="mb-3">
                            <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link to="/newsview">
                                    <img :src="'img/theme/tashnet3.jpg'" class="card-img-top">
                                    <span class="press_news_status">{{$t('homepage.gender_equality')}}</span>
                                    <blockquote class="card-blockquote">
                                        <span class="badge badge-primary">12.08.2019</span>
                                        <h4 class="display-3 text-titlecolor title_text">КАСБ-ҲУНАР КОЛЛЕЖИГА
                                            ЎҚИШГА
                                            КИРИТИШНИ ВАЪДА ҚИЛГАН ДИРЕКТОР ЎРИНБОСАРИ УШЛАНДИ</h4>
                                    </blockquote>
                                </router-link>
                            </div>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="6" class="mb-3">
                            <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link to="/newsview">
                                    <img :src="'img/theme/tashnet3.jpg'" class="card-img-top">
                                    <span class="press_news_status">{{$t('homepage.gender_equality')}}</span>
                                    <blockquote class="card-blockquote">
                                        <span class="badge badge-primary">12.08.2019</span>
                                        <h4 class="display-3 text-titlecolor title_text">КАСБ-ҲУНАР КОЛЛЕЖИГА
                                            ЎҚИШГА
                                            КИРИТИШНИ ВАЪДА ҚИЛГАН ДИРЕКТОР ЎРИНБОСАРИ УШЛАНДИ</h4>
                                    </blockquote>
                                </router-link>
                            </div>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="6" class="mb-3">
                            <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link to="/newsview">
                                    <img :src="'img/theme/tashnet3.jpg'" class="card-img-top">
                                    <span class="press_news_status">{{$t('homepage.gender_equality')}}</span>
                                    <blockquote class="card-blockquote">
                                        <span class="badge badge-primary">12.08.2019</span>
                                        <h4 class="display-3 text-titlecolor title_text">КАСБ-ҲУНАР КОЛЛЕЖИГА
                                            ЎҚИШГА
                                            КИРИТИШНИ ВАЪДА ҚИЛГАН ДИРЕКТОР ЎРИНБОСАРИ УШЛАНДИ</h4>
                                    </blockquote>
                                </router-link>
                            </div>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="6" class="mb-3">
                            <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link to="/newsview">
                                    <img :src="'img/theme/tashnet3.jpg'" class="card-img-top">
                                    <span class="press_news_status">{{$t('homepage.gender_equality')}}</span>
                                    <blockquote class="card-blockquote">
                                        <span class="badge badge-primary">12.08.2019</span>
                                        <h4 class="display-3 text-titlecolor title_text">КАСБ-ҲУНАР КОЛЛЕЖИГА
                                            ЎҚИШГА
                                            КИРИТИШНИ ВАЪДА ҚИЛГАН ДИРЕКТОР ЎРИНБОСАРИ УШЛАНДИ</h4>
                                    </blockquote>
                                </router-link>
                            </div>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="6" class="mb-3">
                            <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link to="/newsview">
                                    <img :src="'img/theme/tashnet3.jpg'" class="card-img-top">
                                    <span class="press_news_status">{{$t('homepage.gender_equality')}}</span>
                                    <blockquote class="card-blockquote">
                                        <span class="badge badge-primary">12.08.2019</span>
                                        <h4 class="display-3 text-titlecolor title_text">КАСБ-ҲУНАР КОЛЛЕЖИГА
                                            ЎҚИШГА
                                            КИРИТИШНИ ВАЪДА ҚИЛГАН ДИРЕКТОР ЎРИНБОСАРИ УШЛАНДИ</h4>
                                    </blockquote>
                                </router-link>
                            </div>
                        </el-col>
                        <el-col :sm="12" :md="8" :lg="6" class="mb-3">
                            <div class="card card-lift--hover bg-defaultnew shadow border-0">
                                <router-link to="/newsview">
                                    <img :src="'img/theme/tashnet3.jpg'" class="card-img-top">
                                    <span class="press_news_status">{{$t('homepage.gender_equality')}}</span>
                                    <blockquote class="card-blockquote">
                                        <span class="badge badge-primary">12.08.2019</span>
                                        <h4 class="display-3 text-titlecolor title_text">КАСБ-ҲУНАР КОЛЛЕЖИГА
                                            ЎҚИШГА
                                            КИРИТИШНИ ВАЪДА ҚИЛГАН ДИРЕКТОР ЎРИНБОСАРИ УШЛАНДИ</h4>
                                    </blockquote>
                                </router-link>
                            </div>
                        </el-col>
                    </el-row>
                    <el-pagination
                            align="center"
                            background
                            layout="prev, pager, next"
                            :total="1000">
                    </el-pagination>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {};
</script>
<style scoped>
    .bg-defaultnew {
        background: #fff;
        cursor: pointer;
    }

    .press_news_status {
        color: #fff;
        position: absolute;
        font-size: 12px;
        text-transform: uppercase;
        padding: 4px 8px;
        right: 10px;
        top: 10px;
        border-radius: 0px;
        background: rgba(57, 72, 105, 0.85);
    }

    .press_fastnews_status {
        color: #fff;
        position: absolute;
        font-size: 12px;
        text-transform: uppercase;
        padding: 4px 8px;
        right: 10px;
        top: 10px;
        border-radius: 0px;
        background: rgba(207, 52, 118, 0.85);
    }

    .tab_div_top {
        min-height: 400px;
        margin-top: 15px;
    }

    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 88px;
    }

    /deep/ .badge {
        display: inline-block;
        padding: 0.35rem 0.375rem;
        font-size: 76%;
        font-weight: 600;
        margin-left: -6px;
        line-height: 1;
        text-align: center;
        position: absolute;
        white-space: nowrap;
        top: -32px;
        vertical-align: baseline;
        border-radius: 0rem;
    }

    /deep/ .badge-primary {
        color: #394869;
        background-color: #f0f4f9;
    }

    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 38px;
    }

    /deep/ .card-img-top {
        height: 240px;
        object-fit: cover;
        border-radius: 0px;
    }

    .textnew-title_color {
        color: #394869;
    }
</style>
